import { steps } from '@/mocks/home';

export default function Steps() {
  return (
    <section id="steps" className="w-full px-4 md:px-6 py-16 md:py-24 bg-background-50">
      <div className="mx-auto max-w-6xl">
        <div className="text-center max-w-2xl mx-auto">
          <span className="inline-block px-3 py-1 rounded-full bg-secondary-100 text-secondary-900 text-xs font-semibold">
            三步上手
          </span>
          <h2 className="mt-4 font-heading text-3xl md:text-4xl font-bold text-foreground-950">
            3 分钟，开启你的数据之旅
          </h2>
          <p className="mt-4 text-foreground-600 leading-relaxed">
            不需要懂技术，跟着下面三步，就能拥有专业级的网站流量统计。
          </p>
        </div>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-6">
          {steps.map((s, i) => (
            <div key={s.step} className="relative rounded-lg border border-background-200 bg-background-50 p-8">
              <div className="flex items-center justify-between">
                <span className="w-14 h-14 flex items-center justify-center rounded-lg bg-primary-500 text-background-50">
                  <i className={`${s.icon} text-2xl`} />
                </span>
                <span className="font-heading text-5xl font-bold text-background-200">{s.step}</span>
              </div>
              <h3 className="mt-6 font-heading text-lg font-semibold text-foreground-950">
                {s.title}
              </h3>
              <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{s.desc}</p>

              {i < steps.length - 1 && (
                <span className="hidden md:flex absolute top-1/2 -right-4 w-8 h-8 items-center justify-center rounded-full bg-accent-100 text-accent-700">
                  <i className="ri-arrow-right-line" />
                </span>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}